import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles({
  title: {
    color: '#201d36',
    lineHeight: 1.2,
    fontFamily: 'sofia-bold',
    marginBottom: 20
  }
})

const ChowbusTitle = ({ children, className=null }) => {
  const classes = useStyles()
  return <Typography variant='h4' className={`${classes.title} ${className}`}>{children}</Typography>
}

export default ChowbusTitle
